<template>
  <transition name="modal" appear>
    <div class="modalMask" @click="close">
      <div class="modalWrapper">
        <div class="modalContainer" @click.stop>
          <!-- Navigation Header -->
          <div class="mobile-menu-header">
            <h2 class="text-menu-header">{{ $t('mainMenu.MENU') }}</h2>
            <ButtonClose aria-label="Close menu" @click="close" />
          </div>

          <!-- Navigation Menu -->
          <nav class="mobile-navigation-container">
            <ul class="mobile-navigation-list">
              <!-- Show portal link -->
              <li v-if="$can('read', 'portal')" class="mobile-navigation-item">
                <NavigationItem :item="portalItem" is-mobile-menu-open />
              </li>
              <li
                v-for="item in items"
                :key="item.id"
                class="mobile-navigation-item"
              >
                <NavigationItem
                  v-if="showItem(item)"
                  :item="item"
                  is-mobile-menu-open
                  @exitMobileMenu="close"
                />
              </li>
            </ul>
            <ul class="mobile-navigation-list">
              <li class="mobile-navigation-item">
                <NavigationItem
                  v-if="showItem(faqItem)"
                  :item="faqItem"
                  is-mobile-menu-open
                  @exitMobileMenu="close"
                />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ButtonClose from '@/components/generics/ButtonClose.vue'
import NavigationItem from '@/components/layout/sidebar/NavigationItem.vue'
import { useGlobalNavigation } from '@/hooks/useGlobalNavigation.ts'

export default {
  components: {
    ButtonClose,
    NavigationItem,
  },
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  setup() {
    const { faqItem, portalItem, items, showItem } = useGlobalNavigation()

    return { faqItem, portalItem, items, showItem }
  },
  mounted() {
    document.body.classList.add('disableScroll')

    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        // this is to catch ESC events
        this.close()
      }
    })
  },
  unmounted() {
    document.body.classList.remove('disableScroll')
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.modalMask {
  position: fixed;
  z-index: 1000;
  display: table;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.3s ease;
}
.modalWrapper {
  display: table-cell;
}
.modalContainer {
  position: relative;
  height: calc(100vh - $header-mobile-height);
  background: $color-pebble;
  overflow-y: auto;
  top: $header-mobile-height;

  .mobile-menu-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: $spacing-4xs $spacing-xs;
    text-align: left;

    .text-menu-header {
      @include subtitle;
      padding: $spacing-2xs;
    }
  }

  .mobile-navigation-container {
    padding: $spacing-s;
    align-content: space-between;
    display: flex;
    flex-wrap: wrap;
    height: 92%;

    .mobile-navigation-list {
      width: 100%;

      .mobile-navigation-item {
        margin-bottom: $spacing-xs;
      }
    }
  }
}

.modal-enter-active .modalContainer,
.modal-leave-active .modalContainer {
  transition: all 0.4s ease;
}
.modal-enter .modalContainer,
.modal-leave-to .modalContainer {
  transform: translateX(100vw);
  transition: all 0.2s ease;
}

@media (max-width: $tablet-width-max) {
  .modalContainer {
    width: 50%;
    left: 50%;
  }
}
@media (max-width: 567px) {
  .modalContainer {
    width: 75%;
    left: 25%;
  }
}
@media (max-width: 414px) {
  .modalContainer {
    left: 10%;
    width: 90%;
  }
}
</style>
